import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { SEVERITY } from '../../types/notification';

interface NotificationsProps {
  open: boolean;
  message: string;
  severity: SEVERITY; // Use SEVERITY enum here
  onClose: () => void;
}

const Notifications: React.FC<NotificationsProps> = ({ open, message, severity, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={severity} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notifications;
